import { render, staticRenderFns } from "./UserTile.vue?vue&type=template&id=d85f0cdc&scoped=true&"
import script from "./UserTile.vue?vue&type=script&lang=js&"
export * from "./UserTile.vue?vue&type=script&lang=js&"
import style0 from "./UserTile.vue?vue&type=style&index=0&id=d85f0cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85f0cdc",
  null
  
)

export default component.exports